export const PATH_LOGIN = '/Login';
export const PATH_CHANGE_PASSWORD = '/ChangePassword';
export const PATH_SET_PASSWORD = '/SetPassword/';
export const PATH_RESET_PASSWORD = '/ResetPassword/';
export const PATH_REQUEST_PASSWORD_RESET = '/RequestPasswordReset';

export const PATH_ADMIN_USER_LIST = '/Admin/User/List';
export const PATH_ADMIN_USER_ADD = '/Admin/User/Add';
export const PATH_ADMIN_USER_EDIT = '/Admin/User/Edit/';

export const PATH_CLIENT_LIST = '/Client/List';
export const PATH_CLIENT_ADD = '/Client/Add';
export const PATH_CLIENT_EDIT = '/Client/Edit/';
export const PATH_CLIENT_MEASUREMENTS = '/Client/Measurements/';
export const PATH_CLIENT_MEASUREMENT_REPORTS = '/Client/MeasurementReports/';

export const PATH_CLIENT_FACILITY_LIST = '/ClientFacility/List';
export const PATH_CLIENT_FACILITY_ADD = '/ClientFacility/Add/';
export const PATH_CLIENT_FACILITY_EDIT = '/ClientFacility/Edit/';

export const PATH_CLIENT_DOSEMETER_ADD = '/Client/Dosemeter/Add/';
export const PATH_CLIENT_DOSEMETER_EDIT = '/Client/Dosemeter/Edit/';

export const PATH_CLIENT_DOSEMETER_MEASUREMENT_LIST = '/Client/Dosemeter/Measurement/List';
export const PATH_CLIENT_MEASUREMENT_REPORT_LIST = '/Client/MeasurementReport/List';

export const PATH_CLIENT_ACCOUNT_LIST = '/ClientAccount/List';
export const PATH_CLIENT_ACCOUNT_ADD = '/ClientAccount/Add';
export const PATH_CLIENT_ACCOUNT_EDIT = '/ClientAccount/Edit/';
